<template>
    <v-card>
        <v-card-text>
            <v-row>
                <v-col cols="12" lg="3" md="6">
                    <template v-for="(component, index) in components">
                        <component
                            :is="component.name"
                            :key="index"
                        ></component>
                    </template>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: "account-dashboard",
    components: {
        AccountProfile: () => import("../components/Dashboard/ProfileCard.vue"),
    },
    data() {
        return {};
    },
    computed: {
        ...mapGetters("Users", ["menus"]),
        components() {
            return Object.keys(this.menus).length === 0
                ? []
                : this.getDashboardComponents();
        },
    },
    methods: {
        getDashboardComponents() {
            return this.menus.account
                .filter((menu) => menu.id !== "account-dashboard")
                .map((menu) => {
                    const { name, enabled } = this.getComponent(menu.id);
                    return {
                        name,
                        enabled,
                    };
                })
                .filter((component) => component.enabled);
        },
        getComponent(id) {
            return {
                name: id,
                enabled: id === "account-profile",
            };
        },
    },
};
</script>